import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { RequestResult } from '@api/responseModels/requestResult';
import { ScheduleTemplateResp } from '@api/responseModels/worker/schedule/scheduleTemplateResponse';
import { CRMAPIManager } from '@classes/crmApiManager';

import { TState } from '../schedule';

export function useSaveScheduleTemplate({
    state,
    crmID,
    workerPositionID,
    messageApi,
    stpState,
    tpEditMode,
    validateSchedule,
    messageService,
}: {
    state: TState;
    crmID: number | string;
    workerPositionID: number | string;
    messageApi: any;
    stpState: any;
    tpEditMode: boolean;
    validateSchedule: () => boolean;
    messageService: any;
}) {
    const navigate = useNavigate();

    const saveAsTemplate = useCallback(
        async (title?: string) => {
            if (!validateSchedule()) return;

            state.isLoading = true;
            try {
                const result: RequestResult<ScheduleTemplateResp> = await CRMAPIManager.request(
                    async (api) => {
                        return await api.saveScheduleTemplate({
                            crm_id: state.schedule.crm_id,
                            id: null,
                            title: title
                                ? title
                                : stpState.activeTemplateNameMirror?.trim() === ''
                                ? state.schedule.title || stpState.suggestedName
                                : stpState.activeTemplateNameMirror || stpState.suggestedName,
                            start_time: state.schedule.start_time,
                            end_time: state.schedule.end_time,
                            breaks: state.schedule.breaks,
                            day_offs: state.schedule.day_offs,
                            schedules: [],
                            schedule_days: state.schedule.schedule_days,
                            schedule_type: state.schedule.schedule_type,
                            exception_days: state.schedule.exception_days,
                        });
                    }
                );

                if (result.errorCode) throw result.errorCode;

                messageApi.success('Сохранено как шаблон');

                navigate(
                    !tpEditMode
                        ? `/lk/worker/crm/${crmID}/workers/${workerPositionID}/schedule`
                        : `/lk/worker/crm/${crmID}/schedule`
                );
            } catch (err) {
                messageService.sendErrorList(err);
                console.error(err);
            } finally {
                state.isLoading = false;
            }
        },
        [
            state,
            crmID,
            workerPositionID,
            messageApi,
            navigate,
            stpState,
            tpEditMode,
            validateSchedule,
            messageService,
        ]
    );

    return { saveAsTemplate };
}
